<script lang="ts">
export default {
    name: 'BaseFrame',
};
</script>
<script lang="ts" setup>
import { useBarInfo } from '@pet/base.utils/device/appInfo';
import { computed, useSlots } from 'vue-demi';

interface Props {
    /**
     * 是否为单屏应用
     */
    fullScreen?: boolean;
    /**
     * 容器内是否有status-bar组件
     */
    hasStatusBar?: boolean;
    /**
     * 底部的 fixedFooter 是否自己处理安全区
     */
    selfCtrlBottom?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    fullScreen: true,
    hasStatusBar: true,
    selfCtrlBottom: false,
});

const { statusBarHeight, toolBarHeight } = useBarInfo();
const wrapperStyle = computed(() => props.fullScreen && 'is-full-screen');
const fillTop = computed(() => {
    return !props.hasStatusBar ? { paddingTop: `${statusBarHeight}px` } : {};
});

const slots = useSlots();

const fillBottom = computed(() => {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    if (slots.fixedFooter || props.selfCtrlBottom) {
        return {
            paddingBottom: `${toolBarHeight}px`,
        };
    }
    return {
        paddingBottom: `calc(${toolBarHeight}px + env(safe-area-inset-bottom))`,
    };
});
</script>
<template>
    <div class="app-wrapper" :class="wrapperStyle" :style="[fillTop, fillBottom]">
        <slot />
        <footer v-if="$slots.fixedFooter" class="app-footer">
            <slot name="fixedFooter" />
        </footer>
    </div>
</template>
<style lang="scss" scoped>
.app-wrapper {
    width: 414px;
    padding-bottom: env(safe-area-inset-bottom);
    &.is-full-screen {
        box-sizing: border-box;
        height: 100vh;
        overflow: hidden;
    }
    .app-footer {
        position: fixed;
        z-index: 997;
        width: inherit;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        padding-bottom: inherit;
        > :deep(div),
        > :deep(section) {
            padding-bottom: env(safe-area-inset-bottom);
        }
    }
}
</style>
